<template>
<div>
  <div class="create-chronology-main" v-show="isEditting">
    <title-screen title ="7" v-show="!hideTitle" @goBack="isEditting = false"></title-screen>
    <div class="text-right text-center-mobile mypage">
      <el-button @click="deleteMemberFamilyDialogVisible = true" :disabled="cloneMemberFamilies.length===0">対象者を削除する</el-button>
      <el-button @click="createMemberFamilyDialogVisible = true">家族構成を追加する</el-button>
    </div>
    <div class="table-responsive table-shadow">
      <table class="table m-0"  id="table-demo-chronology">
        <thead>
            <tr>
              <th v-if="countOpen === 0"></th>
              <th id="id" style="min-width: 150px"></th>
              <th id="target-person" style="min-width: 130px">対象者</th>
              <th id="relationship" style="min-width: 150px">関係</th>
              <th id="birthday" style="min-width: 230px">生年月日</th>
            </tr>
        </thead>
        <tbody>
          <template v-for="(member) in cloneMemberFamilies">
            <tr :key="member.id">
              <td v-if="countOpen === 0" class="allow-drag">
                <label><i class="el-icon-s-operation"></i></label>
              </td>
              <td>
                <el-button @click="addChronicle(member.id)" size="small">イベント追加</el-button>
              </td>
              <td>{{member.name}}</td>
              <td>{{relationshipName(member.relationshipId)}}</td>
              <td>
                <div class="d-flex align-items-center" v-if="!member.isShowDetailChronicle">
                  <div class="w-100p">{{member.birthday | formatDate}}</div>
                  <button class="btn-detail" @click="showDetailChronicle(member)">+</button>
                </div>
                <div class="d-flex align-items-center" v-if="member.isShowDetailChronicle">
                  <div class="w-100p">{{member.birthday | formatDate}}</div>
                  <button class="btn-detail pl-3" @click="closeDetailChronicle(member)">-</button>
                </div>
              </td>
            </tr>
            <template v-if="member.isShowDetailChronicle">
              <tr :key="member.name" class="bg-blue">
                <td></td>
                <td>発生年</td>
                <td>イベント選択</td>
                <td>イベント表示内容</td>
              </tr>
              <tr v-for="(chronicle, index) in member.myChronicleResponseDTOS" :id="`chronicle_${member.id}_${index}`" :key="member.id+'_'+index" v-bind:class="chronicle.id ? '' : 'bg-lightblue'">
                <td><el-button @click="removeChronicle(member.id, index)" size="small">削除</el-button></td>
                <td>
                  <div class="d-flex align-items-center event-year">
                    <el-input type="number" class="w-100 mr-10" :value="formatEventYear(member.birthday, chronicle.eventYear)" @input="changeEventYear($event, chronicle, member.birthday)"></el-input>年
                  </div>
                </td>
                <td>
                  <life-event-select
                    v-model="chronicle.eventMasterId"
                    :chronicle="chronicle"
                    :changeAction="changeEventMaster"
                    :eventMasters="eventMasters"
                    :member="member"
                  ></life-event-select>
                </td>
                <td><el-input class="w-200 event-name__input" placeholder="自由入力" :disabled="isDisableEventName(chronicle.eventMasterId)" v-model="chronicle.eventName"></el-input></td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <div class="d-flex text-center-mobile mypage">
      <el-button @click="gotoFamilyTimeline" class="mr-auto" :disabled="isLoading">My家族年表を見る</el-button>
    </div>
    <el-dialog
      class="create-member-family-dialog"
      :visible.sync="createMemberFamilyDialogVisible"
      :close-on-click-modal="false"
      :before-close="handleCloseCreateMemberFamily"
    >
      <div class="dialog-content">
        <div v-if="isShowCreateMemberFamily">
          <p class="title">家族構成を追加します</p>
          <div class="mt-20 pl-50 pl-0-m">
            <el-form :model="createMemberFamily" :rules="createMemberFamilyRules" ref="createMemberFamily">
              <el-form-item label="氏名" prop="name" class="p-30 msg-p-70">
                <el-input type="text" class="mw-250 sm-mw-100p" v-model="createMemberFamily.name"></el-input>
              </el-form-item>
              <el-form-item label="続柄" prop="relationshipId" class="p-30 msg-p-70">
                <relationship-select
                  v-model="createMemberFamily.relationshipId"
                  :relationships="this.relationships"
                  className="mw-250"
                ></relationship-select>
              </el-form-item>
              <el-form-item label="生年月日" prop="birthday" class="msg-p-70">
                <date-select :default-year="'1960'" v-model="createMemberFamily.birthday"></date-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="!isShowCreateMemberFamily">
          <p class="title">以下を追加します。よろしいですか？</p>
          <div class="mt-20 pl-50 pl-0-m">
            <div class="mt-20">
              <label class="mr-10 list-inline-item">氏名</label>
              <div class="list-inline-item">{{createMemberFamily.name}}</div>
            </div>
            <div class="mt-20">
              <label class="mr-10 list-inline-item">続柄</label>
              <div class="list-inline-item">{{relationshipName(createMemberFamily.relationshipId)}}</div>
            </div>
            <div class="mt-20">
              <label class="mr-10 list-inline-item">生年月日</label>
              <div class="list-inline-item">{{createMemberFamily.birthday | formatDate}}</div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <div v-if="isShowCreateMemberFamily" class="btn-center-mobile">
          <el-button type="danger" @click="handleCloseCreateMemberFamily">やめる</el-button>
          <el-button type="primary" @click="nextToConfirmCreateMemberFamily">追加する</el-button>
        </div>
        <div v-if="!isShowCreateMemberFamily" class="btn-center-mobile">
          <el-button type="danger" @click="isShowCreateMemberFamily = true">やめる</el-button>
          <el-button type="primary" @click="saveMemberFamily">追加する</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      class="delete-member-family-dialog"
      :visible.sync="deleteMemberFamilyDialogVisible"
      :before-close="handleCloseDeleteMemberFamily"
    >
      <div class="dialog-content">
        <div v-if="isShowDeleteMemberFamily">
          <p class="title">削除対象を選択してください</p>
          <div class="mt-20 pl-50 delete-family-member__content">
            <el-checkbox-group v-model="deleteMemberFamilies">
              <el-checkbox v-for="member in deleteMemberFamiliesFilter" :key="member.id" :label="member">{{member.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div v-if="!isShowDeleteMemberFamily">
          <p class="title">以下を削除します。よろしいですか？</p>
          <ul class="mt-20 pl-50">
            <li v-for="member in deleteMemberFamilies" :key="'confirm_'+member.id" class="mt-10">{{member.name}}</li>
          </ul>
        </div>
      </div>
      <span slot="footer">
        <div v-if="isShowDeleteMemberFamily">
          <el-button @click="handleCloseDeleteMemberFamily">やめる</el-button>
          <el-button :disabled="deleteMemberFamilies.length === 0" @click="isShowDeleteMemberFamily = false">削除する</el-button>
        </div>
        <div v-if="!isShowDeleteMemberFamily">
          <el-button @click="isShowDeleteMemberFamily = true">やめる</el-button>
          <el-button @click="saveDeleteMemberFamily">削除する</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
  <chronology v-show="!isEditting" :memberFamilies="memberFamilies" @backToEdit="backToEdit"></chronology>
  <!-- Add-ST -->
  <div class="menu-dialog">
  <el-dialog
    :visible.sync="menuDialogVisible"
    :before-close="handleCloseMenu"
    :close-on-click-modal="false"
  >
      <p class="title">ご利用後にデータを保存したい方</p>
      <el-row>
        <el-col align="center" style="font-size: 16px"><p class="p-menu" v-html="login_register"></p></el-col>
        <div class="register-info" align="center">
          <span class="btn-register" @click="registerEmail">無料会員登録</span>
          <span class="btn-logout" @click="openLoginDialog">ログイン</span>
        </div>
        <p class="title">ご利用後にデータを保存しない方</p>
        <el-col align="center" style="font-size: 16px"><p class="p-menu" v-html="guest"></p></el-col>
        <div class="register-info" align="center">
          <span class="btn-register" @click="handleCloseMenu">保存せずに利用開始</span>
        </div>
      </el-row>
  </el-dialog>
  </div>
  <!-- Add-ed -->
</div>
</template>

<script>
  import Vue from 'vue'
  import moment from 'moment'
  import ChronologyApi from '@/api/chronology'
  import TitleScreen from '@/components/common/TitleScreen'
  import appUtil from '@/mixins/appUtil'
  import { MY_SELF_RELATIONSHIP_ID, BACKWARD_DAY, BACKWARD_DAY_EVENT_NAME } from '../../../../common/constance'
  import DateSelect from '../../../../components/common/DateSelect'
  import Chronology from '../../../../components/client/chronology/Chronology'
  import Sortable from 'sortablejs'
  /* ADD-START */
  import { SET_OPEN_LOGIN_DIALOG, SET_OPEN_REGISTER_DIALOG } from '@/store/actions.type'
  import LifeEventSelect from '@/components/client/chronology/LifeEventSelect'
  import RelationshipSelect from '@/components/client/chronology/RelationshipSelect'

  export default {
    name: 'EditChronology',
    props: {
      hideTitle: Boolean
    },
    components: {
      DateSelect,
      TitleScreen,
      Chronology,
      LifeEventSelect,
      RelationshipSelect
    },
    mixins: [appUtil],
    data () {
      const validateDate = (rule, value, callback) => {
        if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
          callback(new Error('正しい日付を選択してください'))
        } else {
          callback()
        }
      }

      return {
        memberFamilies: [],
        cloneMemberFamilies: [],
        relationships: [],
        eventMasters: [],
        createMemberFamily: {},
        deleteMemberFamilies: [],
        createMemberFamilyDialogVisible: false,
        deleteMemberFamilyDialogVisible: false,
        isShowCreateMemberFamily: true,
        isShowDeleteMemberFamily: true,
        isLoading: true,
        fakeMemberId: 2,
        isEditting: false,
        createMemberFamilyRules: {
          name: [
            { required: true, message: '氏名を入力してください', trigger: 'blur' },
            { min: 1, max: 50, message: '1文字以上50文字以内で入力してください', trigger: 'blur' }
          ],
          relationshipId: [
            { required: true, message: '続柄を選択してください', trigger: 'change' }
          ],
          birthday: [
            { validator: validateDate, trigger: 'blur' }
          ]
        },
        /* ADD-ST */
        menuDialogVisible: false,
        login_register: 'ご利用開始前に、無料会員登録をお願い致します。</BR>会員登録済みの方は、ログイン後にご利用ください。',
        guest: 'ご利用開始前に、無料会員登録またはログインを</BR>されない場合は、データの保存がされません。',
        /* ADD-ED */
        countOpen: 0,
        tableSort: Sortable,
        firstCheck: true
      }
    },
    methods: {
      async loadData () {
          this.isLoading = true
          const relationshipRes = await ChronologyApi.getRelationship()
          this.relationships = relationshipRes.data

          const eventMasterRes = await ChronologyApi.getEventMaster()

          this.eventMasters = eventMasterRes.data

          this.isLoading = false
          if (this.memberFamilies) {
            this.menuDialogVisible = true
          }
      },
      async saveMemberFamily () {
          const eventMasters = this.getEventMastersByRelationshipId_table(this.createMemberFamily.relationshipId)
          let defaultEvent = this.defaultEvents(eventMasters, this.createMemberFamily.relationshipId, this.createMemberFamily.birthday)
          const memberData = {
            id: this.fakeMemberId,
            ...this.createMemberFamily,
            birthday: this.createMemberFamily.birthday,
            myChronicleResponseDTOS: defaultEvent,
            displayOrder: this.fakeMemberId
          }
          this.cloneMemberFamilies.push(memberData)
          this.handleCloseCreateMemberFamily()
          this.fakeMemberId += 1
          /* ２回表示されるので削除
          this.$notify.success({
            title: '成功',
            message: '登録しました。'
          })
          */
        /* 同時に保存も行う　*/
          this.saveChronicle()
      },
      async saveDeleteMemberFamily () {
          if (this.deleteMemberFamilies && this.deleteMemberFamilies.length === 0) {
            return
          }

          const memberIds = this.deleteMemberFamilies.map(m => m.id)

          this.cloneMemberFamilies = this.cloneMemberFamilies.filter(m => !memberIds.includes(m.id))

          this.handleCloseDeleteMemberFamily()

          this.$msgbox({
              title: '家族を削除しました。',
              showClose: true,
              center: true,
              confirmButtonClass: 'btn-msg-box'
          })
          setTimeout(() => { this.$msgbox.close() }, 2000)
          /* 同時に保存も行う　*/
          this.saveChronicle()
      },
      async saveChronicle () {
          this.memberFamilies = JSON.parse(JSON.stringify(this.cloneMemberFamilies))
          /* ２回表示されるので削除
          this.$notify.success({
            title: '成功',
            message: '更新しました。'
          })
           */
      },
      addChronicle (memberId) {
        const member = this.cloneMemberFamilies.find(e => +e.id === +memberId)
        const eventYear = +moment().format('YYYY') - +moment(member.birthday).format('YYYY')
        const eventMasters = this.getEventMastersByRelationshipId(member.relationshipId)
        const event = eventMasters.find(e => e.isDefaultCreate === false && e.itemValue === '自由入力')

        if (member.myChronicleResponseDTOS) {
          member.myChronicleResponseDTOS.push({ eventMasterId: event.id, eventYear, eventMasterKey: event.item_key })
        } else {
          Vue.set(member, 'myChronicleResponseDTOS', [{ eventMasterId: event.id, eventYear, eventMasterKey: event.item_key }])
        }
        this.showDetailChronicle(member)
        this.scrollToNewChronicle(memberId, member.myChronicleResponseDTOS.length - 1)
      },
      nextToConfirmCreateMemberFamily () {
        this.$refs['createMemberFamily'].validate((valid) => {
          if (!valid) {
            return
          }
          this.isShowCreateMemberFamily = false
        })
      },
      handleCloseCreateMemberFamily () {
        if (this.$refs['createMemberFamily']) {
          this.$refs['createMemberFamily'].resetFields()
        }
        this.createMemberFamily = {}
        this.createMemberFamilyDialogVisible = false
        this.isShowCreateMemberFamily = true
      },
      handleCloseDeleteMemberFamily () {
        this.deleteMemberFamilies = []
        this.deleteMemberFamilyDialogVisible = false
        this.isShowDeleteMemberFamily = true
      },
      relationshipName (relationshipId) {
        let vm = this
        const relationships = vm.relationships
          .find(relationship => +relationship.id === +relationshipId)
        return relationships ? relationships.name : ''
      },
      getEventMastersByRelationshipId (relationshipId) {
          let listEventMaster = this.eventMasters.filter(e => (+e.relationshipId === +relationshipId || e.relationshipId == null))
          let otherEvent = listEventMaster.find(e => e.itemValue === '自由入力')
          if (otherEvent) {
              listEventMaster.push(listEventMaster.splice(listEventMaster.indexOf(otherEvent), 1)[0])
          }
          return listEventMaster
      },
      getEventMastersByRelationshipId_table (relationshipId) {
          return this.eventMasters.filter(e => +e.relationshipId === +relationshipId && e.itemYear !== 0 && e.itemYear !== null)
      },
      removeChronicle (memberId, index) {
        const member = this.cloneMemberFamilies.find(e => +e.id === +memberId)
        member.myChronicleResponseDTOS.splice(index, 1)
      },
      showDetailChronicle (member) {
        this.countOpen++
        this.tableSort.options.sort = false
        Vue.set(member, 'isShowDetailChronicle', true)
      },
      closeDetailChronicle (member) {
        this.countOpen--
        if (this.countOpen === 0) { this.tableSort.options.sort = true }
        Vue.set(member, 'isShowDetailChronicle', false)
      },
      formatEventYear (birthday, year) {
        return moment(birthday).add(year, 'year').year()
      },
      changeEventYear (newValue, chronicle, birthday) {
        Vue.set(chronicle, 'eventYear', newValue - moment(birthday).format('YYYY'))
      },
      changeEventMaster (newValue, chronicle) {
        const eventMaster = this.eventMasters.find(e => +e.id === +newValue)
        const eventName = eventMaster && (eventMaster.itemValue !== '自由入力') ? eventMaster.itemValue : ''
        const eventUrl = eventMaster && (eventMaster.itemValue !== '自由入力') ? eventMaster.itemUrl : ''
        this.$set(chronicle, 'eventName', eventName)
        this.$set(chronicle, 'eventUrl', eventUrl)
      },
      isDisableEventName (eventMasterId) {
        const eventMaster = this.eventMasters.find(e => +e.id === +eventMasterId)
        return eventMaster && (eventMaster.itemValue !== '自由入力')
      },
      scrollToNewChronicle (memberId, index) {
        this.$nextTick(() => {
          const chronicleElm = this.$el.querySelector(`#chronicle_${memberId}_${index}`)
          if (chronicleElm) {
            window.scroll(0, chronicleElm.offsetTop)
            chronicleElm.querySelector('div.event-name__input input').focus()
          }
        })
      },
      gotoFamilyTimeline () {
        this.memberFamilies = JSON.parse(JSON.stringify(this.cloneMemberFamilies))
        /* my家族年表を見るボタン押下時にクローンからメインにコピーするへ変更
        this.cloneMemberFamilies = JSON.parse(JSON.stringify(this.memberFamilies))
        */
        this.isEditting = false
        /* 同時に保存も行う　*/
        this.saveChronicle()
      },
      backToEdit () {
        this.isEditting = true
      },
      defaultEvents (eventMasters, relId, birthday) {
        let defaultEvents = []
        let id = 1
        for (const event of eventMasters) {
            let offset = 0
            if (relId === 3 || relId === 4) {
                if (moment(moment(birthday).format('MM-DD')).isBefore(BACKWARD_DAY) && BACKWARD_DAY_EVENT_NAME.includes(event.itemValue)) {
                    offset = 1
                }
            }
          // isDefaultCreateで判定するように修正
          if (event.isDefaultCreate === true) {
            defaultEvents.push({
              'eventMasterId': event.id,
              'eventName': event.itemValue,
              'eventYear': event.itemYear - offset,
              'id': id++,
              'eventUrl': event.itemUrl,
              'eventMasterKey': event.itemKey
            })
          }
        }
        // eventYearの昇順にソート
        defaultEvents.sort(function (a, b) {
          if (a.eventYear < b.eventYear) return -1
          if (a.eventYear > b.eventYear) return 1
          return 0
        })
        return defaultEvents
      },
      handleCloseMenu () {
        this.menuDialogVisible = false
      },
      openLoginDialog () {
        this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, true)
      },
      registerEmail () {
        this.$store.dispatch(SET_OPEN_REGISTER_DIALOG, true)
      },
      async updateMemberSort (newIndex, oldIndex) {
        let changeData = {}
        changeData[this.cloneMemberFamilies[oldIndex].id] = this.cloneMemberFamilies[newIndex].displayOrder
        if (newIndex > oldIndex) {
          for (let i = oldIndex + 1; i <= newIndex; i++) {
            changeData[this.cloneMemberFamilies[i].id] = this.cloneMemberFamilies[i - 1].displayOrder
          }
        } else {
          for (let i = newIndex; i < oldIndex; i++) {
            changeData[this.cloneMemberFamilies[i].id] = this.cloneMemberFamilies[i + 1].displayOrder
          }
        }

        Object.keys(changeData).forEach(memberFamilyId => {
          const cloneMemberFamily = this.cloneMemberFamilies.find(m => +m.id === +memberFamilyId)
          this.$set(cloneMemberFamily, 'displayOrder', changeData[memberFamilyId])
        })

        // await MemberMemberFamilyApi.updateSortMember(changeData)
        this.cloneMemberFamilies = this.cloneMemberFamilies.sort((m1, m2) => m1.displayOrder - m2.displayOrder)
        this.saveChronicle()
      }
    },
    filters: {
      formatDate: function (value) {
          if (value) {
              return moment(value).format('YYYY[年]MM[月]DD[日]')
          }
      }
    },
    computed: {
      deleteMemberFamiliesFilter: function () {
        return this.cloneMemberFamilies.filter(m => m.relationshipId !== MY_SELF_RELATIONSHIP_ID)
      }
    },
    created () {
      this.loadData()
    },
    mounted () {
      const table = document.querySelector('#table-demo-chronology tbody')
      const self = this
      this.tableSort = Sortable.create(table, {
          handle: '.allow-drag',
        onEnd ({ newIndex, oldIndex }) {
          self.updateMemberSort(newIndex, oldIndex)
        },
        delay: 50
      })
    }
  }
</script>

<style scoped>
    @import "../../../../assets/css/custom.css";
  .create-chronology-main {
    padding-bottom: 30px;
  }
  .text-right {
    text-align: right;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .pl-50 {
    padding-left: 50px;
  }
  .table {
    width: 100%;
    margin: 1em auto;
    /*border: 2px solid #d6d6d6;*/
    border-radius: 10px;
    border-collapse: separate !important;
    -webkit-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
    -moz-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
    box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
  }
  table tr:first-child th:first-child {
    border-top-left-radius: 10px;
  }
  table tr:first-child th:last-child {
    border-top-right-radius: 10px;
  }
  table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }

  table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }
  .table td {
    border: 1px solid #d6d6d6;
    text-align: center;
    padding: 1em;
    font-size: 14px;
    vertical-align: middle;
  }
  .table th {
    border: 1px solid #d6d6d6;
    text-align: center;
    background-color: #f7f0df;
    padding: 1em;
    font-size: 16px;
    font-weight: bold;
    color: #321007;
  }
  .table .btn-detail {
    background-color: black;
    border-color: black;
    width: 15px;
    height: 15px;
    color: white;
    line-height: 7px;
    padding-left: 1px;
  }
  .pl-3 {
    padding-left: 3px!important;
  }
  .d-flex {
    display: flex;
  }
  .align-items-center {
    align-items: center!important;
  }
  .w-100p {
    width: 100%;
  }
  .w-100 {
    width: 100px;
  }
  .w-200 {
    width: 200px;
  }
  .mw-250 {
    max-width: 250px;
  }
  .dialog-content .title {
    text-align: center;
    font-size: 24px;
  }
  .dialog-content .label {
     width: 22%;
     text-align: right;
     padding-right: 1em;
     line-height: 30px;
  }
  .list-inline-item {
    display: inline-block;
  }
  .delete-family-member__content .el-checkbox-group .el-checkbox {
    display: block;
    margin-top: 10px;
    width: fit-content;
  }

  .menu-dialog .el-dialog {
    width: 50%;
    min-width: 320px;
  }
  .menu-dialog .btn-end-dialog {
    text-align: center;
  }
  .menu-dialog .title {
    text-align: center;
    text-decoration:underline;
    font-size: 22px;
    margin-top: 10px;
  }
  .menu-dialog .p-menu {
    width: 400px;
    line-height: 20px;
    padding-bottom: 30px;
    padding-top: 10px
  }
  .menu-dialog .register-info {
      width: unset;
  }
  _:-ms-lang(x)::-ms-backdrop, .menu-dialog .register-info {
      width: 100%;
  }
  .menu-dialog .btn-register {
      margin-right: 10px;
      padding: 5px 8px;
  }
  .menu-dialog .btn-logout {
      padding: 5px 8px;
      font-size: 15px;
  }
  .table .bg-blue td {
    background: #8edbff;
  }
  .table .bg-lightblue td {
    background: #e6f6fe;
  }
  .event-year {
      max-width: 220px;
  }
</style>
